// Klaviyo Added to Cart tracking (covers fetch + XHR + form submit + Rebuy click) with variant image from /cart.js
(function () {
  if (window.__klaviyoAtcInitialized) return;
  window.__klaviyoAtcInitialized = true;

  const originalFetch = window.fetch;
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  function absUrl(url) {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return window.location.origin + url;
  }

  async function getCart() {
    const r = await originalFetch('/cart.js', { credentials: 'same-origin' });
    return await r.json();
  }

  function sendKlaviyoEvent(payload) {
    if (!window._learnq) return;
    window._learnq.push(['track', 'Added to Cart', payload]);
  }

  async function trackFromCartSnapshot(options) {
    // options can include: productId, variantId, quantity
    try {
      const cart = await getCart();

      // Try to find matching line item by variantId first
      let line = null;

      if (options?.variantId) {
        line = (cart.items || []).find(i => String(i.variant_id) === String(options.variantId)) || null;
      }

      // Fallback: last item in cart
      if (!line && cart.items && cart.items.length) {
        line = cart.items[cart.items.length - 1];
      }

      if (!line) return;

      const image =
        line?.featured_image?.url ||
        line?.image ||
        '';

      sendKlaviyoEvent({
        ProductID: String(line.product_id || options?.productId || ''),
        VariantID: String(line.variant_id || options?.variantId || ''),
        ProductName: line.product_title || '',
        VariantName: line.variant_title || '',
        Quantity: Number(options?.quantity || line.quantity || 1),
        Price: Number(line.price || 0) / 100,
        SKU: line.sku || '',
        ImageURL: absUrl(image)
      });
    } catch (e) {
      // silent
    }
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'));
  }

  // 1) Hook fetch
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);

    try {
      const req = args[0];
      const url = typeof req === 'string' ? req : req?.url;

      if (!isCartAddUrl(url)) return res;

      // Try parse JSON response if available
      let addedVariantId = null;
      let qty = null;

      try {
        const data = await res.clone().json();
        const item = data?.items?.[0] || data;
        addedVariantId = item?.id || item?.variant_id || null;
        qty = item?.quantity || null;
      } catch (_) {
        // ignore
      }

      // Always confirm via /cart.js to reliably get image
      await trackFromCartSnapshot({ variantId: addedVariantId, quantity: qty });
    } catch (e) {
      // silent
    }

    return res;
  };

  // 2) Hook XHR (some themes/Rebuy use XHR)
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__klaviyo_url = url;
    return originalXHROpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__klaviyo_url;

    if (isCartAddUrl(url)) {
      this.addEventListener('load', function () {
        let variantId = null;
        let quantity = null;

        try {
          const ct = this.getResponseHeader('content-type') || '';
          if (ct.includes('application/json')) {
            const data = JSON.parse(this.responseText);
            const item = data?.items?.[0] || data;
            variantId = item?.id || item?.variant_id || null;
            quantity = item?.quantity || null;
          }
        } catch (_) {}

        trackFromCartSnapshot({ variantId, quantity });
      });
    }

    return originalXHRSend.call(this, body);
  };

  // 3) Fallback for classic form submit (/cart/add) and Rebuy buttons
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;

    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');

    const variantId = idInput ? idInput.value : null;
    const quantity = qtyInput ? Number(qtyInput.value) : null;

    // Delay slightly to let the cart update
    setTimeout(() => {
      trackFromCartSnapshot({ variantId, quantity });
    }, 600);
  }, true);

  document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest ? e.target.closest('button.rebuy-button') : null;
    if (!btn) return;

    // Rebuy usually triggers async add; wait a bit then read cart
    setTimeout(() => {
      trackFromCartSnapshot({});
    }, 700);
  }, true);
})();